import React from 'react'
import { Result, Spin } from 'antd'
import styled from '@emotion/styled'

interface BusyProps {
  status?: 'success' | 'error' | 'info' | 'warning'
  title?: string
  subtitle?: string
}

const Busy = ({ status, title, subtitle }: BusyProps) => (
  <FullWidthResult
    status={status || 'info'}
    title={title || 'Please wait while we load your data'}
    subTitle={subtitle || 'This may take a while'}
    icon={<Spin size='large' />}
  />
)

const FullWidthResult = styled(Result)`
  width: 100%;
`

export default Busy
